import { sendUserReply } from 'actions/live-chat';
import { useAppDispatch, useAppSelector } from 'hooks';
import { useCallback } from 'react';
import { selectLiveChatIntegration } from 'reducers/live-chat';
import { USER_LEFT_CHAT_MSG } from '../consts';

export const usePrepareLiveChatBeforeEndOfConversation = () => {
  const dispatch = useAppDispatch();
  const liveChatIntegration = useAppSelector(selectLiveChatIntegration);

  return useCallback(async () => {
    switch (liveChatIntegration) {
      case 'freshchat':
        await dispatch(sendUserReply({ message: USER_LEFT_CHAT_MSG }));
        break;

      default:
        break;
    }
  }, [liveChatIntegration, dispatch]);
};
